import "./teambook_table.scss";
import ContentCell from "./ContentCell";
import HeaderCell from "./HeaderCell";
import { useEffect, useState } from "react";
import { reorderContentRows } from "./helpers/reorderContentRows";
import PropTypes from "prop-types";

const defaultOrderForType = {
  users: "firstname_a",
};

const TeambookTable = ({ headerRows, contentRows, dataType = "users" }) => {
  const [dataOrder, setDataOrder] = useState(defaultOrderForType[dataType]);
  const [orderedContentRows, setOrderedContentRows] = useState(contentRows);
  const [reversedDataOrder, setReversedDataOrder] = useState(false);

  useEffect(() => {
    setOrderedContentRows(reorderContentRows(contentRows, dataOrder, dataType, reversedDataOrder));
  }, [dataOrder, reversedDataOrder]);

  return (
    <table className="teambook-table">
      <thead>
        {headerRows.map((headerRow, index) => (
          <tr key={`header-row-${index}`} style={headerRow.style || {}}>
            {headerRow.cells.map((headerCell, cellIndex) => (
              <HeaderCell
                key={`header-cell-${index}-${cellIndex}`}
                cell={headerCell}
                dataOrder={dataOrder}
                setDataOrder={setDataOrder}
                reversedDataOrder={reversedDataOrder}
                setReversedDataOrder={setReversedDataOrder}
              />
            ))}
          </tr>
        ))}
      </thead>

      <tbody>
        {orderedContentRows.map((contentRow, index) => (
          <tr key={`content-row-${index}`} style={contentRow.style || {}}>
            {contentRow.cells.map((contentCell, cellIndex) => (
              <ContentCell key={`content-cell-${index}-${cellIndex}`} cell={contentCell} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

TeambookTable.propTypes = {
  headerRows: PropTypes.arrayOf(
    PropTypes.shape({
      style: PropTypes.object,
      cells: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          style: PropTypes.object,
          sortingField: PropTypes.string,
          colspan: PropTypes.number,
          className: PropTypes.string,
        })
      ),
    })
  ).isRequired,
  contentRows: PropTypes.arrayOf(
    PropTypes.shape({
      style: PropTypes.object,
      cells: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          style: PropTypes.object,
          user: PropTypes.object, // For user blocks
        })
      ),
    })
  ).isRequired,
  dataType: PropTypes.string, // e.g., "users", "projects", etc.
};

export default TeambookTable;
